export default __webpack_public_path__ + "static/Logo 9-8acf7f7a76d45e40e98b59c53740ec33.svg";